import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, freddyTheme } from '@coolblue-development/freddy';
import ProductTitleEyebrow from './Eyebrow/index.js';
import ProductTitleReview from './Review/index.js';
import ProductTitleTitle from './Title/index.js';
export function ProductTitle({ children }) {
    return (
    // Styling ensures there is a gap before product reviews
    _jsx(Flex, { direction: "column", sx: { '> div:has(svg)': { marginTop: freddyTheme.spacing[100] } }, children: children }));
}
ProductTitle.Eyebrow = ProductTitleEyebrow;
ProductTitle.Title = ProductTitleTitle;
ProductTitle.Review = ProductTitleReview;
//# sourceMappingURL=ProductTitle.js.map